<mat-tab-group (selectedTabChange)="tabChanged($event)">
  <mat-tab label="COVID-19 Articles">
    <app-articles></app-articles>
  </mat-tab>
  <mat-tab label="100 Most Requested Articles">
    <app-popular [active]="active"></app-popular>
  </mat-tab>
  <mat-tab label="COVID-19 Resources">
    <app-categories></app-categories>
  </mat-tab>
  <mat-tab label="COVID-19 Twitter Feed">
    <app-twitter></app-twitter>
  </mat-tab>
  <mat-tab label="Global Case Map">
    <app-map [mapdata]="wuhan"></app-map>
  </mat-tab>
</mat-tab-group>
